/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-19 14:26:33
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-25 19:27:55
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReview/ProductReviewDetail/Reviews/index.tsx
 */
import React, { useContext } from 'react';
import css from './css.module.less';

import { useDispatch, useSelector } from 'react-redux';
import Element from 'src/layout/EditorPageLayout/Element/Elements';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';

import { TabsGroup } from 'src/components/Antd';
import Query from '../Query';
import Card from '../ReviewCard';
import { EnumReviewType } from '../../common';
import {
  getSpecReview,
  getTabKey,
  onTabChange,
  deleteSpecReply,
  postSpecReply,
  reviewPublishAll,
  reviewUnPublishAll,
  changeReviewStatus,
  reviewDeleteReview,
  reviewSalesChannelOperations,
} from '../slice';
import { EditModalContext } from '../index';
import Title from './Title';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Reviews = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const types = [
    {
      value: EnumReviewType.All,
      label: getI18n('reviews.productreview.common_EnumReviewType_all'),
    },
    {
      value: EnumReviewType.Pending,
      label: getI18n('reviews.productreview.common_EnumReviewType_Pending'),
    },
    {
      value: EnumReviewType.Published,
      label: getI18n('reviews.productreview.common_EnumReviewType_Published'),
    },
    {
      value: EnumReviewType.Archive,
      label: getI18n('reviews.productreview.common_EnumReviewType_Archive'),
    },

    {
      value: EnumReviewType.Spam,
      label: getI18n('reviews.productreview.common_EnumReviewType_Spam'),
    },
  ];
  const { onEdit } = useContext(EditModalContext);
  const _d = useDispatch();
  const key = useSelector(getTabKey());
  const data = useSelector(getSpecReview({ type: key }));

  const handleOnReplyDelete = (uuid) => {
    _d(deleteSpecReply(uuid));
  };

  const handleOnReplyAdd = (reply) => {
    _d(postSpecReply(reply));
  };

  const handleOnPublishAll = (uuid) => {
    _d(reviewPublishAll(uuid));
  };

  const handleOnUnPublishAll = (reply) => {
    _d(reviewUnPublishAll(reply));
  };

  const handleOnStatusChange = (body) => {
    _d(changeReviewStatus(body));
  };

  const handleOnReviewDelete = (uuid) => {
    _d(reviewDeleteReview(uuid));
  };

  const handleOnReviewOperationChange = (body) => {
    _d(reviewSalesChannelOperations({ body }));
  };

  const titleFunctions = (data) => ({
    onPublishAll: handleOnPublishAll,
    onUnPublishAll: handleOnUnPublishAll,
    onStatusChange: handleOnStatusChange,
    onReviewDelete: handleOnReviewDelete,
    onEdit: () => {
      onEdit(data);
    },
  });

  const contentFunctions = {
    onReplyDelete: handleOnReplyDelete,
    onReplyAdd: handleOnReplyAdd,
    onPubTopChange: handleOnReviewOperationChange,
  };

  const content = () => {
    return (
      <React.Fragment>
        {(data || []).map((i) => {
          const { uuid } = i || {};
          const _titleFunctions = titleFunctions(i);
          return (
            <Card
              contentFunctions={contentFunctions}
              titleFunctions={_titleFunctions}
              uuid={uuid}
              key={uuid}
              {...i}
            />
          );
        })}
      </React.Fragment>
    );
  };
  const panes = types.map((i) => {
    return {
      title: <Title label={i.label} value={i.value} />,
      key: i.value,
      id: i.value,
      content: content(),
    };
  });

  const handleOnTabChange = (e) => {
    console.log('e: ', e);
    _d(onTabChange(e));
  };
  return (
    <Element>
      <SectionWrapper hideTitle containerClassName={css.wrapper}>
        <TabsGroup
          onChange={handleOnTabChange}
          tabsWrapperClassName={css.tabsWrapper}
          FixedBelowTabsComponent={<Query />}
          activeKey={key}
          tabsProps={{ size: 'large' }}
          panes={panes}
        />
      </SectionWrapper>
    </Element>
  );
};
export default Reviews;
